var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#paint0_linear_1965_24033)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.918 15h-.004c-.417-.003-4.108-.037-5.154-.32a2.138 2.138 0 01-1.505-1.503c-.273-1.028-.256-3.005-.254-3.163-.002-.158-.02-2.152.253-3.188l.001-.003A2.184 2.184 0 014.758 5.31l.006-.001c1.033-.272 4.732-.305 5.15-.308h.008c.418.003 4.119.037 5.155.32A2.138 2.138 0 0116.58 6.82c.284 1.037.257 3.036.255 3.204.002.166.018 2.127-.254 3.16v.002a2.14 2.14 0 01-1.506 1.504l-.003.001c-1.034.272-4.732.305-5.15.308h-.004zM4.299 7.103c-.24.915-.217 2.884-.217 2.903v.015c-.007.546.018 2.127.217 2.876.097.359.382.643.742.74.772.208 3.778.274 4.877.282 1.101-.008 4.112-.072 4.878-.272.36-.097.643-.38.74-.74.2-.76.225-2.333.218-2.876v-.017c.01-.552-.01-2.152-.217-2.907v-.002a1.055 1.055 0 00-.743-.742c-.764-.209-3.775-.274-4.876-.282-1.101.008-4.109.072-4.877.272a1.084 1.084 0 00-.742.75zM8.54 12.19V7.811L12.323 10 8.54 12.19z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1965_24033",
    x1: 0,
    y1: 10,
    x2: 20,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.74900d79e4d31f5b820c8dd4d8323658.svg";
export { ForwardRef as ReactComponent };